import { schema } from 'normalizr';

const uploadDocumentScheme = new schema.Entity('uploadDocument');

export default uploadDocumentScheme;
